import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Plus, Sparkles } from 'lucide-react';
import { Product } from '../../data/mockProducts';
import { useCart } from '../../hooks/useCart';
interface RecipeBundleProps {
  title: string;
  description: string;
  products: Product[];
  totalPrice: number;
  savings?: number;
}
export function RecipeBundle({
  title,
  description,
  products,
  totalPrice,
  savings
}: RecipeBundleProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    addToCart
  } = useCart();
  const handleAddBundle = (e: React.MouseEvent) => {
    e.stopPropagation();
    products.forEach(product => addToCart(product));
  };
  return <motion.div layout onClick={() => setIsExpanded(!isExpanded)} className="bg-gradient-to-br from-[#fff5f0] to-white rounded-2xl shadow-sm border border-[#ff6b35]/20 overflow-hidden cursor-pointer relative" data-id="element-174">
      <div className="p-5" data-id="element-175">
        <div className="flex items-start justify-between mb-2" data-id="element-176">
          <div className="flex items-center gap-2" data-id="element-177">
            <div className="bg-[#ff6b35]/10 p-1.5 rounded-lg" data-id="element-178">
              <Sparkles className="w-5 h-5 text-[#ff6b35]" data-id="element-179" />
            </div>
            <span className="text-xs font-bold text-[#ff6b35] uppercase tracking-wider" data-id="element-180">
              Smart Bundle
            </span>
          </div>
          {savings && <span className="bg-[#1e3a8a] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-181">
              Save ${savings.toFixed(2)}
            </span>}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-182">{title}</h3>
        <p className="text-gray-600 text-sm mb-4" data-id="element-183">{description}</p>
        <div className="flex items-center justify-between" data-id="element-184">
          <div className="flex -space-x-3" data-id="element-185">
            {products.slice(0, 4).map((p, i) => <div key={p.id} className="w-10 h-10 rounded-full border-2 border-white bg-gray-100 overflow-hidden relative z-10" data-id="element-186">
                <img src={p.image} alt="" className="w-full h-full object-cover" data-id="element-187" />
              </div>)}
            {products.length > 4 && <div className="w-10 h-10 rounded-full border-2 border-white bg-gray-100 flex items-center justify-center text-xs font-bold text-gray-500 relative z-0" data-id="element-188">
                +{products.length - 4}
              </div>}
          </div>
          <div className="text-right" data-id="element-189">
            <span className="block text-xs text-gray-500" data-id="element-190">
              Total Bundle Price
            </span>
            <span className="text-lg font-bold text-[#1e3a8a]" data-id="element-191">
              ${totalPrice.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
      <AnimatePresence data-id="element-192">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="border-t border-[#ff6b35]/10 bg-white/50" data-id="element-193">
            <div className="p-5 pt-2" data-id="element-194">
              <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-195">
                Included Items:
              </h4>
              <ul className="space-y-3 mb-6" data-id="element-196">
                {products.map(product => <li key={product.id} className="flex items-center justify-between text-sm" data-id="element-197">
                    <div className="flex items-center gap-3" data-id="element-198">
                      <img src={product.image} alt="" className="w-8 h-8 rounded-md object-cover bg-gray-100" data-id="element-199" />
                      <span className="text-gray-700" data-id="element-200">{product.name}</span>
                    </div>
                    <span className="font-medium text-gray-900" data-id="element-201">
                      ${product.price.toFixed(2)}
                    </span>
                  </li>)}
              </ul>
              <button onClick={handleAddBundle} className="w-full bg-[#ff6b35] text-white font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2 hover:bg-[#e85a2a] transition-colors active:scale-[0.98]" data-id="element-202">
                <Plus className="w-5 h-5" data-id="element-203" />
                Add All to Cart
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
      <div className="absolute top-5 right-5 text-gray-400" data-id="element-204">
        <motion.div animate={{
        rotate: isExpanded ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-205">
          <ChevronDown className="w-5 h-5" data-id="element-206" />
        </motion.div>
      </div>
    </motion.div>;
}